import * as React from 'react';
import './styles.css';
import SectionBody from '@/screens/BodyScreen/components/SectionBody';
import SectionListHealthRecord from '@/screens/BodyScreen/components/SectionListHealthRecord';

export interface IListProps {}

export default function BodyScreen(props: IListProps) {
  return (
    <div className="flex  flex-wrap h-full">
      <div className="w-full h-full lg:w-1/2">
        <SectionBody />
      </div>
      <div className="w-full h-full lg:w-1/2">
        <SectionListHealthRecord />
      </div>
    </div>
  );
}
